import { gsap } from 'gsap';
import scrollLock from 'scroll-lock';

let fixedEl = null;
let currentImage = null;
let currentImageRect = null;

let nextImage = null;
let nextImageRect = null;

let scrollbarWidth = null;

let breakpoint = window.matchMedia('(min-width:992px)');

export default {
	name: 'program-event',
	from: {
		custom: ({ current, next, trigger }) => {
			if(!breakpoint.matches) {
				return false;
			}

			// If navigating from event carousel, use default transition
			if (
				(typeof trigger.closest == 'function' && trigger.closest('[data-event-carousel]'))
			) {
				return false;
			}

			return true;
		},
		namespace: ['template-program'],
	},
	to: {
		namespace: ['single-event'],
	},
	before({ current, next, trigger }) {
		current.transitionName = this.name;

		window.scrollPositions = {
			scrollX: window.scrollX,
			scrollY: window.scrollY,
		};
	},
	leave({ current, next, trigger }) {
		document.dispatchEvent(new CustomEvent('close-menu'));
	},
	afterLeave({ current, next, trigger }) {
		return new Promise((resolve) => {
			scrollbarWidth = scrollLock.getCurrentPageScrollBarWidth();
			document.dispatchEvent(new CustomEvent('disable-scroll'));

			// Current Image
			const eventCollapse = trigger.closest('[data-event-collapse]');
			const desktopImage = eventCollapse.querySelector('[data-event-image-desktop]');
			currentImage = desktopImage.querySelector('.img');
			currentImageRect = currentImage.getBoundingClientRect();

			// Create Fixed Element
			fixedEl = document.createElement('div');

			gsap.set(fixedEl, {
				position: 'fixed',
				zIndex: 40,
				width: currentImageRect.width,
				height: currentImageRect.height,
				left: currentImageRect.left,
				top: currentImageRect.top,
				transformOrigin: 'top left'
			});

			document.body.appendChild(fixedEl);
			fixedEl.appendChild(currentImage);

			// Scroll to top but make sure Current Container stays in position
			gsap.set(current.container, {
				position: 'absolute',
				top: -window.scrollY + 'px',
				width: window.innerWidth-scrollbarWidth+'px',
				left: 0,
				zIndex: -10,
			});

			window.scrollTo(0, 0);

			// Prepare Next Container for revealing animation
			gsap.set(next.container, {
				xPercent: 100,
				opacity: 0,
			});

			resolve();
		});
	},
	beforeEnter({ current, next, trigger }) {
		return new Promise((resolve) => {
			// Next Image
			const nextImageWrapper = next.container.querySelector('[data-event-image]');
			nextImage = nextImageWrapper.querySelector('.img');
			nextImageRect = nextImage.getBoundingClientRect();
			nextImage.remove();

			const targetScale = nextImageRect.width / currentImageRect.width;

			const currentX = currentImageRect.x;
			const nextX = nextImageRect.x;
			const targetX = (currentX - (nextX - window.innerWidth) - scrollbarWidth) * -1;

			const currentY = currentImageRect.y;
			const nextY = nextImageRect.y;
			const targetY = (currentY - nextY) * -1;

			const duration = 1.6;
			const ease = 'power2.inOut';

			const tl = gsap.timeline({
				onComplete: () => {
					nextImageWrapper.appendChild(currentImage);
					fixedEl.remove();

					resolve();
				},
			});

			tl.to(current.container, {
				opacity: 0,

				ease: ease,
				duration: (duration*0.9)*0.666,
			});

			tl.to(current.container, {
				xPercent: -100,

				ease: ease,
				duration: duration*0.9,
			}, 0);

			tl.to(fixedEl, {
				scale: targetScale,
				translateX: targetX + 'px',
				translateY: targetY + 'px',

				ease: ease,
				duration: duration,
			}, 0);

			tl.to( next.container, {
				xPercent: 0,
				clearProps: 'transform',

				ease: ease,
				duration: duration*1,
			}, 0);

			gsap.to( next.container, {
				opacity: 1,

				ease: ease,
				duration: duration*1,
			}, duration / 3 );
		});
	},
	afterEnter({ current, next, trigger }) {
		const dump = document.querySelector('[data-dump]');
		dump.appendChild(current.container.querySelector('[data-program-content]'));
	},
	after({ current, next, trigger }) {
		scrollLock.clearQueueScrollLocks();
		document.dispatchEvent(new CustomEvent('enable-scroll'));
	},
};
